/* global G */
/* eslint-disable object-curly-newline, no-alert, no-restricted-globals,no-unused-vars */
import { chain } from 'app/_shared/events/util'
import { back, persistChange, persistOptions, persistScroll, redirect } from '@app/_shared/events'
import menu from 'app/_shared/events/contextmenu'
import link from 'app/_shared/events/link'
import toAction from 'app/_shared/events/redirect/toAction'
import deleteModel from 'app/_shared/events/model/delete'
import remember from 'app/_shared/events/remember'
import getPassword from 'app/optionManagement/event/getPassword'
import infiniteWithDrafts from 'app/optionManagement/event/infiniteWithDrafts'
import submit from 'app/optionManagement/event/submit'
import { curry, getFirstItem, isStr } from 'lib/util'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'
import routeComposition from 'trait/composition/route'
import persistChangeAndAction from 'app/_shared/events/combined/persistChangeAndAction'
import getClipboardAndPersistChangeAndAction from 'app/optionManagement/event/getClipboardAndPersistChangeAndAction'
import getValueAndProcessCode from 'app/optionManagement/event/getValueAndProcessCode'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import { acl } from 'app/_shared/events/acl'

export default {
  acl: {
    acl,
  },
  onCreate: {
    createRedirect,
  },
  onOpen: {
    infiniteWithDrafts: infiniteWithDrafts('verbose'),
    link,
  },
  onClose: {
    back,
  },
  onClick: {
    submit: submit(null),
    submitOption: submit('submitOption'),
    back,
    redirect,
    redirectToEquipment: curry(async (module, component, event) => {
      const model = module[G.MODEL]
      const { equipment: { [G.CACHE]: equipment = {} } = {} } = model[G.CHILDREN] || {}
      const equipmentData = equipment && getFirstItem(equipment)
      const key = equipmentData && isStr(equipmentData) ? equipmentData : equipmentData?.key

      const moduleState = module[G.STATE]
      const { route } = component[G.CONFIGURATION]
      moduleState[G.ROUTE] = routeComposition(route.module, route.action)

      key && await redirectSequence(module)({ key })
    }),
    getValueAndProcessCode,
    getClipboardAndPersistChangeAndAction,
    detail: toAction('detail'),
    getPassword,
    delete: deleteModel({
      alsoDraft: true,
      optimistic: true,
      onSuccess: back,
      notificationOptions: {
        ns: 'optionManagement',
        key: type => `toast.${type}.delete`,
        defaultValue: type => `${type} successfully deleted.`,
      },
      dialogOptions: {
        title: {
          ns: 'optionManagement',
          key: type => `dialog.${type}.delete.title`,
          defaultValue: type => `Delete ${type}`,
        },
        text: {
          ns: 'optionManagement',
          key: type => `dialog.${type}.delete.text`,
          defaultValue: type => `Are you sure you want to delete this ${type}?`,
        },
      },
    }),
  },
  onChange: {
    persistOptions,
    persistChange,
    persistChangeAndAction,
  },
  onContextMenu: {
    menu: menu(null),
  },
  onPage: {
    remember,
  },
  onScroll: {
    persistScrollAndRemember: chain(
      persistScroll,
      remember,
    ),
  },
}
